import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MDTypography from 'components/MDTypography';
import { brandColors } from 'types/colors';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const LastUpdateTime = () => {
  const lastUpdate = useSelector(state => state.controllers.lastUpdate);
  const [displayValue, setDisplayValue] = useState('N/A');
  const theme = useTheme();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const updateDisplay = useCallback(() => {
    if (typeof lastUpdate !== 'number') {
      setDisplayValue('N/A');
      return;
    }

    const topBar = document.getElementById('controllerPageTopBar');
    if (topBar) {
      const date = new Date(lastUpdate * 1000);
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = String(date.getFullYear()).slice(-2);

      setDisplayValue(`${hours}:${minutes} - ${day}.${month}.${year}`);
    } else {
      setDisplayValue('N/A');
    }
  }, [lastUpdate]);

  useEffect(() => {
    updateDisplay();
    const updateDisplayId = setInterval(updateDisplay, 300000);

    return () => {
      clearInterval(updateDisplayId);
    };
  }, [updateDisplay]);

  // useEffect(() => {
  //   updateDisplay();
  // }, [updateDisplay]);

  if (typeof lastUpdate !== 'number') {
    return null;
  }

  return (
    <MDTypography
      variant="subtitle"
      color="white"
      >
      Last update: {displayValue}
    </MDTypography>
  );
};

export default LastUpdateTime;
